import * as React from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance, axiosWithoutAuth } from "../../axios/axiosInstance";
import { RESETPASSWORD } from "../../constants";
import { useNoteAlert } from "../../Context/pleaseNote";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";

export const ResetChangePassword = () => {
  const [txtNewPassword, settxtNewPassword] = React.useState("");
  const [txtConformPassword, settxtConformPassword] = React.useState("");
  const { userid } = useParams();
  const { showNoteAlert } = useNoteAlert();
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [isLinkRejected, setIsLinkRejected] = React.useState(false);
  const [isPasswordUpdated, setIsPasswordUpdated] = React.useState(false);

  useEffect(() => {
    var data = {
      userid: userid,
    };
    axiosInstance
      .post("ResetChangePassword/ResetChangePasswordLoad", data)
      .then((response) => {
        if (response.data != "") {
          if (response.data == "Success") {
          } else if (response.data == "login") {
            histroy("/Login");
          } else {
            setIsLinkRejected(true);
            showNoteAlert(response.data, "Please Note", true, () => histroy("/Login"));
          }
        }
      })
      .catch((error) => console.log(error.message));
  }, []);

  const histroy = useNavigate();
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,12}$/;

  function isStrongPassword(pwd) {
    return passwordRegex.test(pwd);
  }

  const SubmitClick = () => {
    document.getElementById("divPwsNotMatch").style.display = "none";
    if (txtNewPassword == "") {
      showNoteAlert(RESETPASSWORD.EMPTYPASSWORD);
      var focusID = document.getElementById("txtNewPassword");
      focusID.focus();
      return false;
    }
    if (txtConformPassword == "") {
      showNoteAlert(RESETPASSWORD.EMPTYCONFIRMPASSWORD);
      var focusID = document.getElementById("txtConformPassword");
      focusID.focus();
      return false;
    }
    if (txtNewPassword != txtConformPassword) {
      showNoteAlert(RESETPASSWORD.PASSWORDNOTMATCH);
      var focusID = document.getElementById("txtConformPassword");
      focusID.focus();
      return false;
    }

    var ValidateEmail = isStrongPassword(txtNewPassword);
    if (ValidateEmail == false) {
      document.getElementById("divPwsNotMatch").style.display = "block";
      var focusID = document.getElementById("txtNewPassword");
      focusID.focus();
      return false;
    }

    var data = {
      userid: userid,
      newpassword: txtNewPassword,
      conformpassword: txtConformPassword,
    };

    axiosInstance
      .post("ResetChangePassword/ResetPasswordClick", data)
      .then((response) => {
        if (response.data != "") {
          if (response.data != "Success") {
            if (response.data == "login") {
              histroy("/Login");
            } else {
              showNoteAlert(response.data);
            }
          } else if (response.data == "Success") {
            setIsPasswordUpdated(true);
          }
          // else if (response.data != "Success") {
          //   showNoteAlert(response.data);
          //   document.getElementById("divShowResetPws").style.display = "block";
          //   document.getElementById("divUpdateSuccess").style.display = "none";
          // } else {
          //   document.getElementById("divUpdateSuccess").style.display = "block";
          //   document.getElementById("divShowResetPws").style.display = "none";
          //   document.getElementById("divPwsNotMatch").style.display = "none";
          // }
        }
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <div className="loginWrapper-verification">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3">
            <label id="lblError" style={{ fontSize: "14px", color: "red", display: "none" }} />
          </div>
        </div>
      </div>
      <div className="container" id="divShowResetPws" style={{ display: isLinkRejected || isPasswordUpdated ? "none" : "block" }}>
        <div className="row">
          <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3">
            <div className="loginVerification-wrapper text-center">
              <div className="loginVerification-wrapperTitle">
                <h1 className="fw-semibold">Welcome to WES Online Web Site</h1>
                <p className="fs-14 fw-normal">To get started please create a new login password</p>
              </div>
              <form>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="floating-input loginChangedPwd mb-3">
                      <input
                        id="txtNewPassword"
                        className="form-control form-input"
                        type={showNewPassword ? "text" : "password"}
                        placeholder=""
                        required=""
                        value={txtNewPassword}
                        onChange={(changeEvent) => settxtNewPassword(changeEvent.target.value)}
                      />
                      <label for="changePwd1">New Password</label>
                      <span
                        className={showNewPassword ? " loginPassword wes-eye" : "loginPassword wes-eye-slash"}
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      ></span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="floating-input loginChangedPwd mb-3">
                      <input
                        id="txtConformPassword"
                        className="form-control form-input"
                        type={showPassword ? "text" : "password"}
                        placeholder=""
                        required=""
                        value={txtConformPassword}
                        onChange={(changeEvent) => settxtConformPassword(changeEvent.target.value)}
                      />
                      <label for="changePwd2">Confirm New Password</label>
                      <span
                        className={showPassword ? " loginPassword wes-eye" : "loginPassword wes-eye-slash"}
                        onClick={() => setShowPassword(!showPassword)}
                      ></span>
                    </div>
                  </div>
                  <div className="col-md-12 loginVerification-btn">
                    <div className="button-effect">
                      <a className="btn btn-products btn-addcart" data-bs-dismiss="modal" onClick={() => SubmitClick()}>
                        {" "}
                        Update Password
                      </a>
                    </div>
                    <div
                      className="toast show pwdError-toast w-100 mt-3"
                      id="divPwsNotMatch"
                      style={{ display: "none" }}
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
                        <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
                          <div>
                            <svg
                              width="47"
                              height="48"
                              viewBox="0 0 47 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect y="0.5" width="47" height="47" rx="23.5" fill="#F82643" fill-opacity="0.2"></rect>
                              <rect x="3" y="3.5" width="41" height="41" rx="20.5" fill="#F82643"></rect>
                              <path
                                d="M23.5 21.375V25.75"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M23.5 32.2339H18.1975C15.1613 32.2339 13.8925 30.0639 15.3625 27.4126L18.0925 22.4951L20.665 17.8751C22.2225 15.0664 24.7775 15.0664 26.335 17.8751L28.9075 22.5039L31.6375 27.4214C33.1075 30.0726 31.83 32.2426 28.8025 32.2426H23.5V32.2339Z"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M23.4952 28.375H23.5031"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </div>
                          <div className="pwd-ordernoNot-info">
                            <h5 className="fw-semibold">Password does not meet requirements</h5>
                            <p className="fw-medium col-fs-13 fs-14 m-0">Please Enter valid password</p>
                          </div>
                        </div>
                        <div className="ct-close">
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="toast"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                    </div>
                    <div className="pwdInstructions text-left mt-4">
                      <span className="wes-info-cc"></span>
                      <p>
                        Create a strong password with 8-12 characters and Must Contain mixing 1 uppercase, lowercase,
                        numbers and symbol
                      </p>
                    </div>
                    <p className="mt-4">
                      Back to{" "}
                      <a
                        href="javascript:void(0)"
                        className="text-decoration-underline"
                        onClick={() => histroy("/Login")}
                      >
                        Login Screen
                      </a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="container" id="divUpdateSuccess" style={{ display: isPasswordUpdated ? "block" : "none" }}>
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="loginVerification-wrapper text-center">
              <div class="loginVerification-wrapperTitle">
                <svg
                  class="loginVerification-check"
                  width="60"
                  height="61"
                  viewBox="0 0 60 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30 55.5C43.75 55.5 55 44.25 55 30.5C55 16.75 43.75 5.5 30 5.5C16.25 5.5 5 16.75 5 30.5C5 44.25 16.25 55.5 30 55.5Z"
                    stroke="#3BA429"
                    strokeWidth="3.375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M19.375 30.4998L26.45 37.5748L40.625 23.4248"
                    stroke="#3BA429"
                    strokeWidth="3.375"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <h1 class="fw-semibold mt-4">Password Reset Successfully</h1>
                <p class="fs-14 fw-normal">Login and continue your shopping</p>
                <div class="button-effect loginPwd-updateBtn">
                  <a href="javascript:void(0)" class="btn btn-products btn-addcart" onClick={() => histroy("/Login")}>
                    {" "}
                    Back to Login
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
